import moment from 'moment';

export const chooseColor =(() => {
  let i = 0;
  const COLORS = [
    "#4ab8bb",
    "#f84741",
    "#1a618a",
    "#fcb333",
    "#4ec0f3",
    "#bfc1c0",
    "#ae81cb",
    "#a8c117",
    "#a04474",
    "#fa6738",
    "#d4ee4a",
    "#fdd186",
    "#b9de12",
    "#fbe54e"
  ];
  return (reset = false) => {
    if (reset) {
      i = 0;
    }
    const color = COLORS[i];
    i = (i + 1) % COLORS.length;
    return color;
  };
})();

export const chooseScoreColor = val => {
  switch (val) {
    case 'Good':
    case 'Total good':
    case 'Хорошие':
    case 'Всего хороших':
      return '#b9de12'
    case 'Low risk':
    case 'Total low risk':
    case 'Низкий риск':
    case 'Всего с низким риском':
      return '#fbe54e'
    case 'Middle risk':
    case 'Total middle risk':
    case 'Средний риск':
    case 'Всего со средним риском':
      return '#fcb333'
    case 'High risk':
    case 'Total high risk':
    case 'Высокий риск':
    case 'Всего с высоким риском':
      return '#ff5757'
    default:
      return '#4ab8bb'
  }
}

/**
 * Returns percent value
 * @param _val{number}, _count{number}
 * @return percent{number}
 * @public
 */

export const getPercent = (_val, _count) => Math.round((_val * 100) / _count);

/**
* Calculate total amount values of metric
* @param data{Object}, metric{String}
* @return {Object}|{Number}
* @public
*/
export const getTotalAmount = ({ data }, _metric = "leads") => {
  if (!data) return {};
  switch (_metric) {
    case "leads":
      return data.reduce((acc, { leadsCount }) => (acc += leadsCount), 0);
    case "lead-closure":
      return data.reduce(
        (res, item) => ({
          ...res,
          [item.created]: Object.keys(item).reduce(
            (sum, key) => (~["created", "Total leads", "Все лиды"].indexOf(key) ? sum : sum + +item[key]),
            0
          )
        }),{});
    case "lead-closure-relative":
       return data.reduce(
        (res, item) => ({
          ...res,
          [item.created]: {
            ...item,
            Good: item["Total good"],
            "High risk": item["Total high risk"],
            "Low risk": item["Total low risk"],
            "Middle risk": item["Total middle risk"],
            "Хорошие": item["Всего хороших"],
            "Высокий риск": item["Всего с высоким риском"],
            "Низкий риск": item["Всего с низким риском"],
            "Средний риск": item["Всего со средним риском"],
          }
        }),
        {}
      );
    default:
      //accumulate from [{created: '2015',a:1,b:2},{created: '2016',a:5,b:2},{created: '2017',a:12,b:2}]
      //           to    {2015: 3, 2016: 7, 2017: 14}
      return data.reduce(
        (res, item) => ({
          ...res,
          [item.created]: Object.keys(item).reduce(
            (sum, key) => (key === "created" ? sum : sum + +item[key]),
            0
          )
        }),{});
  }
}

/**
* Calculate percent of values in metric
* @param data{Object}, metric{String}
* @return {Object}|{Array}
* @public
*/
export const setData = (
  { data },
  _totalAmount,
  _unit = "count",
  _metric = "leads"
) => {
  if (!data) return [];
  if (_unit === "count") return data;
  switch (_metric) {
    case "leads":
      return data.map(item => ({
        ...item,
        leadsCount: getPercent(item.leadsCount, _totalAmount)
      }));
    case "lead-closure":
      return data.map(item => {
        const _res = {};
        Object.keys(item).map(
          key =>
            key === "created"
              ? (_res[key] = item[key])
              : ~["Total leads", "Все лиды"].indexOf(key)
                ? (_res[key] = 100)
                : (_res[key] = getPercent(
                    item[key],
                    _totalAmount[item.created]
                  ))
        );
        return _res;
      });
    default:
      //accumulate from [{created: '2015',a:1,b:2},{created: '2016',a:5,b:2},{created: '2017',a:12,b:2}]
      //           with  {2015: 3, 2016: 7, 2017: 14}
      //             to [{created: '2015',a:33,b:66},{created: '2016',a:77,b:23},{created: '2017',a:84,b:16}]
      return data.map(item => {
        const _res = {};
        Object.keys(item).map(
          key =>
            key === "created"
              ? (_res[key] = item[key])
              : (_res[key] = getPercent(item[key], _totalAmount[item.created]))
        );
        return _res;
      });
  }
};

/**
 * Returns corrent unit
 * @param unit{String}
 * @return {String}
 * @public
 */
export const getUnit = unit => (unit === "percent" ? "%" : "");

/**
* Convert value in percent
* @param data{Object}, id{String}, amount{Number}, field{String}, name{String}
* @return {String}
* @public
*/
export const toPercent = (data, id, amount, field, name = 'leadsCount') => {
  const res = Object.values(data).find(item => item[field] === id)
  const percent = getPercent(res[name] || res['leadsCount'], amount)
  if (percent) return `${percent}%`
  return '<1%'
}

/**
* Get value from data
* @param data{Object}, amount{String}, field{String}
* @return {Number}
* @public
*/
export const toValue = (data, id, field) => {
  const { leadsCount } = Object.values(data).find(item => item[field] === id)
  return leadsCount
}

/**
* Returns fraud label, when number is out of range returns 'NA'
* @param num{Number}
* @return {String}
* @public
*/
export const getLeadQuality = num => {
  if(num >= 0 && num < 0.2) return 'high';
  if(num >= 0.2 && num < 0.5) return 'mid';
  if(num >= 0.5 && num < 0.8) return 'low';
  if(num >= 0.8 && num <= 1) return 'good';
  return 'NA'
}

/**
 * transpose data and collect groups for duration chart
 * @param data - sorted by created
 * @returns {*}
 */
export const prepareGrouppedData = data => {

  if (!data) { return { data, groups: []}; }
  let res = [];
  let period = null;
  let titles = {};
  let orders = [];
  for (let i = 0; i < data.length; i++) {
    let item = data[i];
    if (!period || item.created !== period.created) {
      period = {created: item.created}
      res.push(period);
    }
    period[item.groupTitle] = item.leadsCount;
    if (!(item.groupOrder in titles)) {
      titles[item.groupOrder] = item.groupTitle;
      orders.push(item.groupOrder);
    }
  }
  orders.sort();
  // const groups = orders.map((order) => (titles[order]));
  // when dublicates order have came from the backend
  let groups = orders.map((order) => (titles[order]));
  groups = groups.reduce((acc, group) => !~acc.indexOf(group)? [...acc, group]: acc ,[])
  return { data: res, groups}
}

/**
 * transpose data and collect groups for GFM chart
 * @param data - sorted by created
 * @returns {*}
 */

export const prepareGFMData = data => {
  if (!data) {
    return { data, groups: [] };
  }
  let period = null;
  const res = [];
  const titles = {};
  const orders = [];
  for (let i = 0; i < data.length; i++) {
    let item = data[i];
    if (!period || item.created !== period.created) {
      period = { created: item.created };
      res.push(period);
    }
    // key properties is 'percent'
    period[item.groupTitle] = item.percent;
    if (!(item.groupTitle in titles)) {
      // not a groupOrder
      titles[item.groupTitle] = item.groupTitle;
      orders.push(item.groupTitle);
    }
  }
  orders.sort();
  // const groups = orders.map((order) => (titles[order]));
  // when dublicates order have came from the backend
  let groups = orders.map(order => titles[order]);
  groups = groups.reduce(
    (acc, group) => (!~acc.indexOf(group) ? [...acc, group] : acc),
    []
  );

  const dataWithFancyDate = res.map(row => ({...row, created: moment.utc(row.created).format('DD-MM-YYYY HH:mm')}))
  return { data: dataWithFancyDate, groups };
};

export const prepareParsedData = data => {
  let groups = []
  const res =  data.reduce((acc, { groupName, leadsCount, groupTitle, groupOrder }) => {
    const id = acc.map(i => i.groupName).indexOf(groupName)
    if (~id) acc[id].leadsCount += leadsCount
    else {
      acc.push({ leadsCount, groupTitle, groupOrder, groupName })
      groups.push(groupTitle)
    }
    return acc
  }, [])
  return {data: res, groups: groups.sort()}
}



// WEBPACK FOOTER //
// ./src/components/dashboard/analytics/utils.js